import withAuth from '@auth/auth-validation'
import { Layout } from '@utils/layout'

import Home from '@dashboard/home/home'

export default withAuth(() => {
  return (
    <Layout title="Home">
      <Home />
    </Layout>
  )
})
